import { Injectable } from '@angular/core';
import { ApiConstants } from 'src/app/constants/api-constants';
import { HttpGuardService } from 'src/app/guards/http-guard.service';

@Injectable({
    providedIn: 'root'
})
export class TrackerServiceService {
    zoneName: string;

    constructor(private httpGuard: HttpGuardService) { }

    getTfsTrackerList(payload: any) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.tfsTrackerList, payload);
    }

    getTfsTrackerCount(payload: any) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.tfsTrackerCount, payload);
    }

    formatDuration(sec?: number): string {
        if (sec == null) return '-';
        if (sec === 0) return '0s';

        const d = Math.floor(sec / 86400);
        const h = Math.floor((sec % 86400) / 3600);
        const m = Math.floor((sec % 3600) / 60);
        const s = sec % 60;

        const parts = [];
        if (d) parts.push(`${d}d`);
        if (h) parts.push(`${h}h`);
        if (m) parts.push(`${m}m`);
        // if (s || parts.length === 0) parts.push(`${s}s`);

        return parts.join(' ');
    }

    getTfsTimelineData(payload: any) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.tfsTimelineData, payload);
    }

    getTfsTimeLineDrilldown(payload: any) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.tfsTimeLineDrilldown, payload);
    }

    getTfsDurationDrilldown(payload: any) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.tfsDurationDrilldown, payload);
    }

    getTfsAggregateTimeseries(payload: any) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.tfsAggregateTimeseries, payload);
    }

    getTfsChartDataGlovePortUsage(payload: any) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.tfsChartDataGlovePortUsage, payload);
    }

    getTfsBatchHistory(payload: any) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.tfsBatchHistory, payload);
    }

    getZonesList(payload: any, pageNo: number) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', `${ApiConstants.URL.zoneList}/${pageNo}`, payload);
    }

    batchStartStop(payload: any) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.batchStartStop, payload);
    }

    getOperatorsSummary(payload: any) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.getOperatorsSummary, payload);
    }

    getTimelineDrilldownSummary(payload: any) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.timelineDrilldownSummary, payload);
    }
    
    fetchEvidenceClips(payload: { anomalyCode: string, timestamp: string, line: string }) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.fetchEvidenceClips, payload);
    }

    videoStream(clipFilUrl: string) {
        return this.httpGuard.httpReq('get-blob', null, clipFilUrl, null);
    }

    getVialsCountSummary(payload: any) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.vialsCountSummary, payload);
    }

    getVialsAnalytics(payload: any) {
        return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.vialsAnalytics, payload);
    }

    setLineDetails(payload: any) {
        this.zoneName = payload;
    }

    getLineDetails() {
        return this.zoneName;
    }
}